import React, { useState } from 'react';
import { COLORS, TYPOGRAPHY } from '../../lib/styleGuide';

const ACCENT_GRAY = '#757575';

const foodTypes = [
  {
    id: 'shelf-stable',
    name: 'Shelf-stable / Baked goods',
    description: 'Cookies, breads, jams, etc.',
    legalPath: 'Cottage Food'
  },
  {
    id: 'perishable-meals',
    name: 'Perishable Meals',
    description: 'Hot meals, refrigerated or frozen foods.',
    legalPath: 'Commercial Kitchen'
  },
  {
    id: 'both',
    name: 'Both shelf-stable and perishable',
    description: 'A mix of baked goods and hot/cold meals.',
    legalPath: 'Commercial Kitchen'
  },
  {
    id: 'not-sure',
    name: 'I\'m not sure yet',
    description: 'Show me a quick overview of my options.',
    legalPath: 'Overview'
  }
];

export default function FoodTypeSelectionStep({ data, onNext, onBack, isFirst, isLast }) {
  const [selectedType, setSelectedType] = useState(data?.foodType || '');

  function handleTypeSelect(typeId) {
    setSelectedType(typeId);
  }

  function handleNext(e) {
    e.preventDefault();
    if (selectedType === '') {
      return;
    }
    onNext({ foodType: selectedType });
  }

  return (
    <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Header Section */}
      <div>
        <h2 style={{ fontWeight: 700, fontSize: TYPOGRAPHY.ONBOARDING.H2, margin: 0, color: '#222' }}>
          What kind of food will you be making?
        </h2>
        <p style={{ color: ACCENT_GRAY, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, margin: '10px 0 0 0' }}>
          Your answer helps us guide you through the right legal setup for selling food in your area.
        </p>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {foodTypes.map(type => (
          <button
            key={type.id}
            type="button"
            onClick={() => handleTypeSelect(type.id)}
            style={{
              width: '100%',
              padding: 16,
              borderRadius: 12,
              border: `2px solid ${selectedType === type.id ? COLORS.PRIMARY_GRADIENT_START : '#eee'}`,
              background: selectedType === type.id ? '#FEF7F3' : '#fff',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              cursor: 'pointer',
              transition: 'all 0.2s',
              textAlign: 'left',
            }}
            aria-label={`Select ${type.name} food type`}
          >
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, color: '#222', marginBottom: 2 }}>
                {type.name}
              </div>
              <div style={{ fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, color: ACCENT_GRAY }}>
                {type.description}
              </div>
            </div>
            <div style={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              border: `2px solid ${selectedType === type.id ? COLORS.PRIMARY_GRADIENT_START : '#ddd'}`,
              background: selectedType === type.id ? COLORS.PRIMARY_GRADIENT_START : 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              {selectedType === type.id && (
                <span style={{ color: '#fff', fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, fontWeight: 'bold' }}>✓</span>
              )}
            </div>
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        {!isFirst && (
          <button
            type="button"
            onClick={onBack}
            style={{
              background: '#fff',
              color: '#9CA3AF',
              border: 'none',
              borderRadius: 10,
              padding: '14px 32px',
              fontSize: TYPOGRAPHY.ONBOARDING.BUTTON_TEXT,
              fontWeight: 600,
              cursor: 'pointer',
              minHeight: 44,
              minWidth: 120,
              transition: 'all 0.2s',
            }}
            aria-label="Back"
          >
            Back
          </button>
        )}
        <button
          type="submit"
          disabled={selectedType === ''}
          style={{
            background: selectedType !== '' ? COLORS.PRIMARY_GRADIENT : '#E0CFC2',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            padding: '14px 32px',
            fontSize: TYPOGRAPHY.ONBOARDING.BUTTON_TEXT,
            fontWeight: 600,
            cursor: selectedType !== '' ? 'pointer' : 'not-allowed',
            minHeight: 44,
            minWidth: 120,
            boxShadow: '0 1px 4px #0001',
            transition: 'all 0.2s',
          }}
          aria-label="Continue"
        >
          Continue
        </button>
      </div>
    </form>
  );
} 